import { updateState } from "@saas/server-api/src/live-sdk";
import TRTC from "trtc-sdk-v5";
import { BaseLiveService } from "../base";
import { EMIT_MAP } from "../constants";
import store from "@saas/store/src";
import { BasicBeauty } from "trtc-sdk-v5/plugins/video-effect/basic-beauty";
import { Message, MessageBox } from "element-ui";
import { DarkMessage } from "@saas/components";
import { createQueueAsyncFn } from "../../utils/debounce-async";
import { uploadLiveLog } from "@saas/components/src/utils/log";

class WebTRTCService extends BaseLiveService {
  constructor(options) {
    super();
    this.options = options;
    // 创建 TRTC 实例
    this.client = TRTC.create({ plugins: [BasicBeauty] });
    TRTC.setLogLevel(0);
    // 创建完示例直接开启，后续统一调用update更新（web端本地视频麦克风采集只能调用一次）
    if (this.options.mode !== 1 && !this.options.isRecord) {
      // 极速模式 或者 非录制页面
      // this.initStartLocalPreview();
    }
    this.enableAudioVolumeEvaluation(); // 是否开启音频音量评估
    if (!this.options.isRecord) {
      this.initStartLocalAudio();
    }
    this.isEnterRoomSuccess = false;
    this.registerListener();
    this.streamTypeMap = {
      0: TRTC.TYPE.STREAM_TYPE_MAIN,
      1: TRTC.TYPE.STREAM_TYPE_SUB,
    };
    // 测试实例
    this.testClient = TRTC.create({ plugins: [BasicBeauty] });
    // 测试摄像头开启状态,
    this.testVideoState = false;
    // 本地摄像头开启状态,
    this.videoState = false;
    // 防抖定时器
    this.videoDebounceTimer = null;
    this.renderCameraDom = null;

    // 本地音频开启状态
    this.audioState = false;
    // 本地音频开启状态是否成功
    this.audioStateSuccess = false;

    this.currentSpeaker = null;

    // 初始化队列异步执行函数
    this.queueAsyncVideo = createQueueAsyncFn();
    this.queueAsyncVideoTestClient = createQueueAsyncFn();
    this.queueAsyncAudio = createQueueAsyncFn();
    this.queueAsyncRemoteVideo = createQueueAsyncFn();
    this.queueAsyncRemoteAudio = createQueueAsyncFn();
    this.screenShareProfile = {
      width: 1280,
      height: 720,
      bitrate: 1200,
      fps: 15,
    };
    this.videoProfile = {
      width: 320,
      height: 180,
      bitrate: 400,
      fps: 15,
    };
  }

  registerListener() {
    // 远端用户视频可用事件
    this.client.on(
      TRTC.EVENT.REMOTE_VIDEO_AVAILABLE,
      this.onUserVideoAvailable.bind(this)
    );

    // 远端用户停止发布视频
    this.client.on(
      TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE,
      this.onUserVideoUnAvailable.bind(this)
    );
    // 远端用户音频可用事件
    this.client.on(
      TRTC.EVENT.REMOTE_AUDIO_AVAILABLE,
      this.onUserAudioAvailable.bind(this)
    );
    // 远端用户停止发布音频
    this.client.on(
      TRTC.EVENT.REMOTE_AUDIO_UNAVAILABLE,
      this.onUserAudioUnAvailable.bind(this)
    );
    //远端用户进房事件
    this.client.on(
      TRTC.EVENT.REMOTE_USER_ENTER,
      this.onRemoteUserEnterRoom.bind(this)
    );
    //远端用户退房事件
    this.client.on(
      TRTC.EVENT.REMOTE_USER_EXIT,
      this.onRemoteUserLeaveRoom.bind(this)
    );
    this.client.on(TRTC.EVENT.AUDIO_VOLUME, this.onTestMicVolume.bind(this));
    this.client.on(TRTC.EVENT.STATISTICS, this.onStatistics.bind(this));
    this.client.on(
      TRTC.EVENT.CUSTOM_MESSAGE,
      this.onReciveCustomMessage.bind(this)
    );
    this.client.on(TRTC.EVENT.KICKED_OUT, this.onKickedOut.bind(this));
    this.client.on(
      TRTC.EVENT.SCREEN_SHARE_STOPPED,
      this.onScreenShareStop.bind(this)
    );
    this.client.on(TRTC.EVENT.DEVICE_CHANGED, this.onDeviceChange.bind(this));
    this.client.on(TRTC.EVENT.PUBLISH_STATE_CHANGED, (event) => {
      console.log(`djj_____${event.mediaType} ${event.state} ${event.reason}`);
    });
    this.client.on(
      TRTC.EVENT.CONNECTION_STATE_CHANGED,
      this.onConnectionStateChanged.bind(this)
    );
    this.client.on(TRTC.EVENT.ERROR, this.onError.bind(this));
  }
  onError(error) {
    const err = {
      errCode: error.code,
    };
    uploadLiveLog({
      message: "Web-TRTC错误",
      level: "error",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        error: err,
      },
    });
  }
  onConnectionStateChanged(event) {
    const prevState = event.prevState;
    const curState = event.state;
    if (prevState === "DISCONNECTED" && curState === "CONNECTING") {
      // 正在尝试建立连接，调用进房接口或者 SDK 自动重连时触发。
      this._emit(EMIT_MAP.onTryToReconnect);
      uploadLiveLog({
        message: "正在尝试建立连接",
        tag: "callback",
        extra: {
          component: "WebTRTCService",
        },
      });
    } else if (prevState === "CONNECTING" && curState === "DISCONNECTED") {
      // 连接建立失败，当正在连接时调用退房接口中断连接或者经过 SDK 重试后任然连接失败时触发。
      this._emit(EMIT_MAP.onConnectionLost);
      uploadLiveLog({
        message: "连接建立失败",
        tag: "callback",
        extra: {
          component: "WebTRTCService",
        },
      });
    } else if (prevState === "CONNECTING" && curState === "CONNECTED") {
      // 连连接建立成功，连接成功时触发。
      this._emit(EMIT_MAP.onConnectionRecovery);
      uploadLiveLog({
        message: "连接建立成功",
        tag: "callback",
        extra: {
          component: "WebTRTCService",
        },
      });
    } else if (prevState === "CONNECTED" && curState === "DISCONNECTED") {
      // 连接中断，调用退房接口或者当网络异常导致连接断开时触发。
      this._emit(EMIT_MAP.onConnectionLost);
      uploadLiveLog({
        message: "连接建立失败",
        tag: "callback",
        extra: {
          component: "WebTRTCService",
        },
      });
    }
  }
  onRemoteUserEnterRoom(params) {
    const { userId } = params;
    this._emit(EMIT_MAP.onRemoteUserEnterRoom, { userID: userId });
    uploadLiveLog({
      message: "远端用户进入房间",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
      },
    });
  }

  onRemoteUserLeaveRoom({ userId }) {
    this._emit(EMIT_MAP.onRemoteUserLeaveRoom, {
      userID: userId,
    });
    uploadLiveLog({
      message: "远端用户离开房间",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
      },
    });
  }

  onUserVideoUnAvailable(params) {
    const { userId, streamType } = params;
    if (streamType === TRTC.TYPE.STREAM_TYPE_SUB) {
      this._emit(EMIT_MAP.onUserSubStreamAvailable, {
        userID: userId,
        available: 0, // 0隐藏，1显示
      });
    } else {
      this._emit(EMIT_MAP.onUserVideoAvailable, {
        userID: userId,
        available: 0, // 0隐藏，1显示
        streamType,
      });
    }
    uploadLiveLog({
      message: "远端用户视频不可用",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
        streamType: streamType,
      },
    });
  }
  onUserVideoAvailable(params) {
    const { userId, streamType } = params;
    console.log("远端用户视频可用", params);
    // 如果是辅流（屏幕分享），交给ScreenShare组件处理
    if (streamType === TRTC.TYPE.STREAM_TYPE_SUB) {
      this._emit(EMIT_MAP.onUserSubStreamAvailable, {
        userID: userId,
        available: 1, // 0隐藏，1显示
      });
    } else {
      this._emit(EMIT_MAP.onUserVideoAvailable, {
        userID: userId,
        available: 1, // 0隐藏，1显示
        streamType,
      });
    }
    uploadLiveLog({
      message: "远端用户视频可用",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
        streamType: streamType,
      },
    });
  }
  onUserAudioAvailable(params) {
    const { userId, streamType } = params;
    console.log("远端用户音频可用", params);
    this._emit(EMIT_MAP.onUserAudioAvailable, {
      userID: userId,
      available: 1, // 0隐藏，1显示
    });
    uploadLiveLog({
      message: "远端用户音频可用",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
        streamType: streamType,
      },
    });
  }
  onUserAudioUnAvailable(params) {
    const { userId, streamType } = params;
    console.log("远端用户音频不可用", params);
    this._emit(EMIT_MAP.onUserAudioAvailable, {
      userID: userId,
      available: 0, // 0隐藏，1显示
    });
    uploadLiveLog({
      message: "远端用户音频不可用",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        userId: userId,
        streamType: streamType,
      },
    });
  }
  onTestMicVolume(event) {
    event.result.forEach(({ userId, volume }) => {
      const isMe = userId === ""; // 当 userId 为空串时，代表本地麦克风音量。
      this._emit(EMIT_MAP.onAudioVolumnChange, {
        userId,
        volume,
      });
      if (isMe) {
        this._emit(EMIT_MAP.onTestMicVolume, volume);
      } else {
        // console.log(`user: ${userId} volume: ${volume}`);
      }
    });
  }
  onStatistics(event) {
    const res = {
      upLoss: event.upLoss,
      downLoss: event.downLoss,
      appCpu: event.appCpu || null,
      systemCpu: event.systemCpu || null,
      rtt: event.rtt,
      gatewayRtt: event.gatewayRtt || null,
    };
    this._emit(EMIT_MAP.onStatistics, res);
  }
  onReciveCustomMessage(event = {}) {
    console.log("==55onRecvCustomMessage>>>>>>", event);
    let { cmdId, userId, seq, data } = event;
    const decoder = new TextDecoder();
    data = decoder.decode(data);
    console.log("data111", data);
    if (typeof data === "string") {
      console.log(888);
      data = JSON.parse(data);
    }
    if (typeof data === "string") {
      console.log(999);

      data = JSON.parse(data);
    }
    if (typeof data === "string") {
      console.log(111);

      data = JSON.parse(data);
    }
    console.log("data222", data);

    this._emit(EMIT_MAP.onRecvCustomCmdMsg, {
      userId: userId,
      data: data,
      cmdId: cmdId,
      seq: seq,
    });
  }
  onKickedOut(event) {
    console.log("event", event);
    // kick: 相同 userId 的用户同时进入同一个房间（以下简称为同名进房），先进入房间的用户会被后进入的用户踢出房间。
    // 同名进房是不允许的行为，可能会导致双方音视频通话异常，业务侧应避免出现这种情况。
    // TRTC 后台不保证观众角色同名进房互踢。即观众角色的用户，使用同 userId 进同一个房间，可能不会收到该事件。
    // banned: 系统管理员通过服务端 API 将该用户踢出房间。
    // room_disband: 系统管理员通过服务端 API 解散房间。
    this._emit(EMIT_MAP.onKickedOut, event.reason);
    this.isEnterRoomSuccess = false;
    uploadLiveLog({
      message: "用户被踢出房间",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
        reason: event.reason,
      },
    });
  }
  // 本地屏幕分享停止事件通知，仅对本地屏幕分享流有效。
  onScreenShareStop() {
    this._emit(EMIT_MAP.onScreenShareStop);
    uploadLiveLog({
      message: "本地屏幕分享停止",
      tag: "callback",
      extra: {
        component: "WebTRTCService",
      },
    });
  }
  // 设备变化
  onDeviceChange(event) {
    console.log("设备变化___", event);
    if (["add", "remove"].includes(event.action)) {
      this._emit(EMIT_MAP.onDeviceChange, {
        deviceId: event.device?.deviceId,
        type: event.type,
        state: event.action,
      });
      this._emit(EMIT_MAP.onDefaultDeviceChange, {
        deviceId: event.device?.deviceId,
        type: event.type,
      });
      uploadLiveLog({
        message: event.action === "add" ? "设备添加" : "设备移除",
        tag: "callback",
        extra: {
          component: "create-trtc",
          type: event.type,
          deviceId: event.device?.deviceId,
          state: event.action,
        },
      });
    } else if (event.action === "active") {
      // 设备启动
      this._emit(EMIT_MAP.onDeviceActive, {
        deviceId: event.device?.deviceId,
        type: event.type,
      });
      uploadLiveLog({
        message: "设备启动",
        tag: "callback",
        extra: {
          component: "create-trtc",
          type: event.type,
          deviceId: event.device?.deviceId,
        },
      });
    }
    if (event.type === "speaker" && event.action === "active") {
      this.currentSpeaker = event.device;
    }
  }
  // 进入房间
  async enterRoom() {
    return new Promise((resolve, reject) => {
      try {
        const { sdkAppId, userId, roomId, userSig } = this.options;
        // console.log("enterRoom", this.options);
        this.client
          .enterRoom({
            sdkAppId,
            userId,
            userSig,
            strRoomId: roomId + "",
            scene: TRTC.TYPE.SCENE_LIVE,
            privateMapKey: this.options.privateMapKey,
            autoReceiveAudio: false,
          })
          .then((res) => {
            this._emit(EMIT_MAP.onEnterRoomSuccess);
            this.isEnterRoomSuccess = true;
            resolve();
          })
          .catch((error) => {
            this._emit(EMIT_MAP.onEnterRoomFail, {
              errCode: error.code,
              errMsg: "进入直播间失败",
              errType: "enterRoom",
            });
            this.isEnterRoomSuccess = false;
            reject(error);
          });
      } catch (error) {
        this._emit(EMIT_MAP.onEnterRoomFail, {
          errCode: error?.code || 0,
          errMsg: "进入直播间失败",
          errType: "enterRoom",
        });
        this.isEnterRoomSuccess = false;
        reject(error);
        throw error;
      }
    });
  }
  //
  exitRoom() {
    return this.client.exitRoom().then(() => {
      this.isEnterRoomSuccess = false;
    });
  }

  // ----------------------------------------------------摄像头相关--------------------------------------
  /**
   * 获取摄像头列表
   * @returns {Promise<Array>} 返回摄像头列表
   * @property {Array} cameras - 摄像头列表
   * @property {string} cameras[].deviceId - 摄像头的ID
   * @property {string} cameras[].deviceName - 摄像头的名称
   * @property {string} cameras[].deviceProperties - 设备属性
   * @abstract
   */
  getCameraList() {
    return new Promise((resolve, reject) => {
      TRTC.getCameraList()
        .then((res) => {
          console.log("new_live_web_getCameraList", res);
          const list = res.map((item) => {
            return {
              deviceId: item.deviceId,
              deviceName: item.label,
              deviceProperties: item.getCapabilities(),
            };
          });
          uploadLiveLog({
            message: "获取摄像头列表",
            tag: "api",
            extra: {
              component: "WebTRTCService",
              list,
            },
          });
          resolve(list);
        })
        .catch((error) => {
          console.error("new_live_web_getCameraList", error);
          uploadLiveLog({
            message: "获取摄像头列表失败",
            tag: "api",
            extra: {
              component: "WebTRTCService",
              error,
            },
          });
          reject(error);
        });
    });
  }
  /**
   * 获取当前摄像头设备
   * @returns {Object || null} 返回当前摄像头设备
   * @property {string} deviceId - 摄像头的ID
   * @property {string} deviceName - 摄像头的名称
   * @abstract
   */

  getCurrentCameraDevice() {
    const track = this.client.getVideoTrack({
      streamType: TRTC.TYPE.STREAM_TYPE_MAIN,
    });
    if (track) {
      const settings = track.getSettings();
      return {
        deviceId: settings.deviceId,
        deviceName: track.label,
      };
    } else {
      return null;
    }
  }
  /**
   * 开始本地摄像头预览 默认本地摄像头的预览 默认会选择摄像头列表的第一个
   * @param {Object} params - 预览参数
   * @param {HTMLElement} params.dom - 预览的DOM元素
   * @param {boolean} params.publish - 是否发布
   * @returns {Promise<void>}
   * @abstract
   */
  startLocalPreview(params = {}) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        try {
          const { dom, publish = false } = params;
          if (dom) {
            this.renderCameraDom = dom;
          }
          // 再次检查状态，避免重复开启
          if (this.videoState) {
            this.client
              .updateLocalVideo({
                view: dom,
                publish: true,
                option: {
                  mirror: store?.state?.live?.isMirror ? "both" : false,
                  profile: this.videoProfile,
                },
              })
              .then((res) => {
                uploadLiveLog({
                  message: "摄像头开启成功",
                  tag: "api",
                  extra: {
                    component: "WebTRTCService",
                  },
                });
                resolve(res);
              })
              .catch((err) => {
                this.handleStartLocalDeviceError(err, "video");
                this.handleCameraError(err);
                uploadLiveLog({
                  message: "摄像头开启失败",
                  tag: "api",
                  level: "error",
                  extra: {
                    component: "WebTRTCService",
                    error: err,
                  },
                });
                reject(err);
              });
            return;
          } else {
            this.client
              .startLocalVideo({
                view: dom,
                publish,
                option: {
                  mirror: store?.state?.live?.isMirror ? "both" : false,
                  profile: this.videoProfile,
                },
              })
              .then((res) => {
                this.videoState = true;
                console.log("摄像头开启成功");
                uploadLiveLog({
                  message: "摄像头开启成功",
                  tag: "api",
                  extra: {
                    component: "WebTRTCService",
                  },
                });
                resolve(res);
              })
              .catch((err) => {
                this.videoState = false;
                console.error("摄像头开启失败", err);
                this.handleStartLocalDeviceError(err, "video");
                this.handleCameraError(err);
                uploadLiveLog({
                  message: "摄像头开启失败",
                  tag: "api",
                  level: "error",
                  extra: {
                    component: "WebTRTCService",
                    error: err,
                  },
                });
                reject(err);
              });
          }
        } catch (error) {
          this.handleCameraError(error);
          uploadLiveLog({
            message: "摄像头开启失败",
            tag: "api",
            level: "error",
            extra: {
              component: "WebTRTCService",
              error,
            },
          });
          reject(error);
        }
      });
    };
    return this.queueAsyncVideo(asyncFn);
  }
  handleStartLocalDeviceError(error, type) {
    const deviceMap = {
      video: "摄像头",
      audio: "麦克风",
    };
    const errorStr = error?.toString() || "";
    if (errorStr.includes("DEVICE_ERROR: NotAllowedError")) {
      if (!this.options.isRecord) {
        DarkMessage({
          message: `${deviceMap[type]}权限未开启，请开启后重试！`,
          type: "error",
        });
      }

      if (type === "video") {
        store.commit("live/setVideoPermission", false);
      } else if (type === "audio") {
        store.commit("live/setAudioPermission", false);
      }
    } else if (errorStr.includes("DEVICE_ERROR: NotReadableError")) {
      if (!this.options.isRecord) {
        DarkMessage({
          message: `${deviceMap[type]}不可用，可能被占用！`,
          type: "error",
        });
      }
    } else {
      if (!this.options.isRecord) {
        DarkMessage({
          message: `开启本地${deviceMap[type]}失败！`,
          type: "error",
        });
      }
    }
  }
  /**
   * 切换摄像头
   * @param {Object} params
   * @param {string} params.deviceId - 设备ID
   */
  setCurrentCameraDevice(params) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        const { deviceId } = params;
        if (this.client) {
          if (this.videoState) {
            this.client
              .updateLocalVideo({
                option: { cameraId: deviceId, profile: this.videoProfile },
              })
              .then(() => {
                resolve();
              })
              .catch((err) => {
                this.handleCameraError(err);
                reject(err);
              });
          } else {
            this.client
              .startLocalVideo({
                publish: false,
                option: { cameraId: deviceId, profile: this.videoProfile },
              })
              .then(() => {
                this.videoState = true;
                resolve();
              })
              .catch((err) => {
                console.error("setCurrentCameraDevice___startLocalVideo", err);
                this.handleCameraError(err);
                reject(err);
              });
          }
        } else {
          reject("客户端未初始化");
        }
      });
    };
    return this.queueAsyncVideo(asyncFn);
  }
  /**
   * 停止本地摄像头采集
   * @returns {Promise<void>}
   */
  stopLocalPreview() {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        // 再次检查状态，避免重复关闭
        console.log("stopLocalPreview___", this.videoState);
        if (!this.videoState) {
          console.log("摄像头已关闭，跳过重复操作");
          resolve();
          return;
        }

        this.client
          .stopLocalVideo()
          .then(() => {
            this.videoState = false;
            console.log("摄像头关闭成功");
            resolve();
          })
          .catch((err) => {
            console.error("摄像头关闭失败", err);
            // 即使关闭失败，也更新状态
            this.videoState = false;
            this.handleCameraError(err);
            reject(err);
          });
      });
    };
    return this.queueAsyncVideo(asyncFn);
  }
  /**
   * 开始显示远端视频画面
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型
   * @param  {HTMLElement} params.view - 视频的DOM元素
   */

  startRemoteView(param) {
    return new Promise((resolve, reject) => {
      const { userID, streamType, view } = param;
      this.client
        .startRemoteVideo({
          userId: userID,
          streamType: this.streamTypeMap[streamType], //todo:分享
          view: view,
        })
        .then((res) => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  /**
   * 开始显示远端辅路视频画面
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param  {HTMLElement} params.view - 视频的DOM元素
   */
  startRemoteSubView(params) {
    const { userID, view } = params;
    this.client.startRemoteVideo({
      userId: userID,
      streamType: TRTC.TYPE.STREAM_TYPE_SUB,
      view: view,
      option: {
        // fillMode: "contain",
      },
    });
  }
  /**
   * 停止显示远端视频画面，同时不再拉取该远端用户的视频数据流。
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型

   */
  stopRemoteView(params) {
    return new Promise((resolve, reject) => {
      const { userID, streamType } = params;
      if (this.client) {
        this.client
          .stopRemoteVideo({
            userId: userID,
            streamType: this.streamTypeMap[streamType],
          })
          .then((res) => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        reject();
      }
    });
  }
  /**
   * 更新远端
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型
   * @param  {HTMLElement} params.view - 视频的DOM元素
   */

  updateRemoteVideo(param) {
    return new Promise((resolve, reject) => {
      const { userID, streamType, view } = param;

      this.client
        .updateRemoteVideo({
          userId: userID,
          streamType: this.streamTypeMap[streamType], //todo:分享
          view: view,
        })
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //测试摄像头——只预览不发布
  startLocalPreviewByTestClient({ dom, deviceId }) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        try {
          console.log("startLocalPreviewByTestClient___", this.testVideoState);
          if (this.testVideoState) {
            this.testClient
              .updateLocalVideo({
                view: dom,
                option: {
                  cameraId: deviceId,
                  mirror: store?.state?.live?.isMirror ? "both" : false,
                },
              })
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
            return;
          } else {
            this.testClient
              .startLocalVideo({
                view: dom,
                publish: false, // 不发布摄像头
                option: {
                  mirror: store?.state?.live?.isMirror ? "both" : false,
                  cameraId: deviceId,
                },
              })
              .then((res) => {
                this.testVideoState = true;
                if (store?.state?.live?.openBeauty) {
                  this.initBasicBeauty("testClient");
                }
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          }
        } catch (error) {
          reject(error);
        }
      });
    };
    return this.queueAsyncVideoTestClient(asyncFn);
  }
  /**
   * 停止本地摄像头采集
   * @returns {Promise<void>}
   */
  stopLocalPreviewByTestClient() {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        console.log("stopLocalPreviewByTestClient___", this.testClient);
        if (this.testClient) {
          try {
            if (!this.testVideoState) {
              resolve();
              return;
            }
            this.testClient
              .stopLocalVideo()
              .then(() => {
                this.testVideoState = false;
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          } catch (error) {
            reject(error);
          }
        } else {
          reject("stopLocalPreviewByTestClient_no client");
        }
      });
    };
    return this.queueAsyncVideoTestClient(asyncFn);
  }
  /**
   * 切换摄像头
   * @param {Object} params
   * @param {string} params.deviceId - 设备ID
   * @returns {Promise<void>}
   */
  setCurrentCameraDeviceByTestClient(params) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        console.log(
          "setCurrentCameraDeviceByTestClient___",
          this.testVideoState
        );
        const { deviceId } = params;
        if (this.testClient) {
          if (this.testVideoState) {
            this.testClient
              .updateLocalVideo({
                option: { cameraId: deviceId },
              })
              .then(() => {
                console.log(
                  "setCurrentCameraDeviceByTestClient___updateLocalVideo"
                );
                resolve();
              })
              .catch((err) => {
                console.error(
                  "setCurrentCameraDeviceByTestClient___updateLocalVideo",
                  err
                );
                reject(err);
              });
          } else {
            this.testClient
              .startLocalVideo({
                option: {
                  cameraId: deviceId,
                },
              })
              .then(() => {
                console.log(
                  "setCurrentCameraDeviceByTestClient___startLocalVideo"
                );
                this.testVideoState = true;
                resolve();
              })
              .catch((err) => {
                console.error(
                  "setCurrentCameraDeviceByTestClient___startLocalVideo",
                  err
                );
                reject(err);
              });
          }
        } else {
          reject("setCurrentCameraDeviceByTestClient_no client");
        }
      });
    };
    return this.queueAsyncVideoTestClient(asyncFn);
  }
  handleCameraError(error) {
    // 摄像头错误
    this._emit(EMIT_MAP.onCameraError, {
      errCode: error.code,
      errMsg: "“摄像头”异常",
      errType: "camera",
    });
  }
  // -------------------------------------------------麦克风相关-----------------------------------------
  /**
   * 获取麦克风列表
   * @returns {Promise<Array>} 麦克风列表
   * @property {Array} micro - 麦克风列表
   * @property {string} micro[].deviceId - 麦克风的ID
   * @property {string} micro[].deviceName - 麦克风的名称
   * @property {string} micro[].deviceProperties - 设备属性
   */
  getMicrophoneList() {
    return new Promise((resolve, reject) => {
      if (this.client) {
        TRTC.getMicrophoneList()
          .then((res) => {
            console.log("new_live_web_getMicrophoneList", res);
            const list = res.map((item) => {
              return {
                deviceId: item.deviceId,
                deviceName: item.label,
                deviceProperties: item.getCapabilities(),
                isDefault: item.deviceId === "default",
              };
            });
            resolve(list);
          })
          .catch((err) => {
            console.error("new_live_web_getMicrophoneList", err);
            reject(err);
          });
      } else {
        reject();
      }
    });
  }
  /**
   * 开启本地麦克风采集，并发布到当前的房间中。
   * @returns {Promise<any>}
   */
  startLocalAudio() {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        if (this.client) {
          console.log("startLocalAudio___startLocalAudio");
          this.client
            .updateLocalAudio({ mute: false, publish: true })
            .then((res) => {
              resolve(res);
            })
            .catch((error) => {
              this.handleMicrophoneError(error);
              reject(error);
            });
        } else {
          reject();
        }
      });
    };
    return this.queueAsyncAudio(asyncFn);
  }
  initStartLocalAudio(params = {}) {
    return new Promise((resolve, reject) => {
      try {
        if (this.client) {
          console.log("startLocalAudio___initStartLocalAudio");
          this.client
            .startLocalAudio({ publish: false })
            .then((res) => {
              store.commit("live/setAudioPermission", true);
              this.audioStateSuccess = true;
              resolve(res);
              uploadLiveLog({
                message: "初始化本地麦克风采集成功",
                tag: "api",
                extra: {
                  component: "WebTRTCService",
                },
              });
            })
            .catch((error) => {
              this.handleStartLocalDeviceError(error, "audio");
              this.handleMicrophoneError(error);
              reject(error);
              uploadLiveLog({
                message: "初始化本地麦克风采集失败",
                tag: "api",
                level: "error",
                extra: {
                  component: "WebTRTCService",
                  error: error,
                },
              });
            });
        } else {
          reject();
          uploadLiveLog({
            message: "初始化本地麦克风采集失败",
            tag: "api",
            level: "error",
            extra: {
              component: "WebTRTCService",
              error: "没有实例对象",
            },
          });
        }
      } catch (error) {
        this.handleMicrophoneError(error);
        reject(error);
        uploadLiveLog({
          message: "初始化本地麦克风采集失败",
          tag: "api",
          level: "error",
          extra: {
            component: "WebTRTCService",
            error,
          },
        });
      }
    });
  }
  /**
   * 停止本地麦克风的采集及发布
   * @returns {Promise<any>}
   */
  stopLocalAudio() {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        try {
          if (this.client) {
            this.client
              .stopLocalAudio()
              .then((res) => {
                resolve(res);
                uploadLiveLog({
                  message: "停止本地麦克风采集成功",
                  tag: "api",
                  extra: {
                    component: "WebTRTCService",
                  },
                });
              })
              .catch((err) => {
                this.handleMicrophoneError(err);
                reject(err);
                uploadLiveLog({
                  message: "停止本地麦克风采集失败",
                  tag: "api",
                  level: "error",
                  extra: {
                    component: "WebTRTCService",
                    error: err,
                  },
                });
              });
          } else {
            reject();
            uploadLiveLog({
              message: "停止本地麦克风采集失败",
              tag: "api",
              level: "error",
              extra: {
                component: "WebTRTCService",
                error: "没有实例对象",
              },
            });
          }
        } catch (error) {
          this.handleMicrophoneError(error);
          reject(error);
          uploadLiveLog({
            message: "停止本地麦克风采集失败",
            tag: "api",
            level: "error",
            extra: {
              component: "WebTRTCService",
              error,
            },
          });
        }
      });
    };
    return this.queueAsyncAudio(asyncFn);
  }
  /**
   * 切换麦克风
   * @param {Object} params
   * @param {string} params.deviceId
   * @returns {Promise<void>}
   */
  setCurrentMicDevice(params) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        try {
          const { deviceId } = params;
          // 切换麦克风
          if (this.client) {
            console.log("startLocalAudio___setCurrentMicDevice");
            this.client
              .updateLocalAudio({
                option: { microphoneId: deviceId },
              })
              .then((res) => {
                resolve();
                uploadLiveLog({
                  message: "设置麦克风成功",
                  tag: "api",
                  extra: {
                    component: "WebTRTCService",
                    deviceId,
                  },
                });
              })
              .catch((err) => {
                console.error("new-live-web-setCurrentMicDevice", err);
                this.handleMicrophoneError(err);
                reject(err);
                uploadLiveLog({
                  message: "设置麦克风失败",
                  tag: "api",
                  level: "error",
                  extra: {
                    component: "WebTRTCService",
                    error: err,
                    deviceId,
                  },
                });
              });
          } else {
            reject();
            uploadLiveLog({
              message: "设置麦克风失败",
              tag: "api",
              level: "error",
              extra: {
                component: "WebTRTCService",
                error: "没有实例对象",
              },
            });
          }
        } catch (error) {
          this.handleMicrophoneError(error);
          reject(error);
          uploadLiveLog({
            message: "设置麦克风失败",
            tag: "api",
            level: "error",
          });
        }
      });
    };
    return this.queueAsyncAudio(asyncFn);
  }
  /**
   * 麦克风静音/开启
   * @param {Object} params
   * @param {boolean} params.mute
   */
  muteLocalAudio(params = {}) {
    const asyncFn = () => {
      return new Promise((resolve, reject) => {
        try {
          const { mute } = params;
          if (this.client) {
            if (this.audioStateSuccess) {
              this.client
                .updateLocalAudio({
                  publish: mute ? false : true,
                  option: {
                    captureVolume: mute ? 0 : 100,
                  },
                })
                .then(() => {
                  this.audioStateSuccess = true;
                  resolve();
                  uploadLiveLog({
                    message: mute ? "麦克风静音成功" : "麦克风开启成功",
                    tag: "api",
                    extra: {
                      component: "WebTRTCService",
                      mute,
                    },
                  });
                })
                .catch((error) => {
                  this.handleMicrophoneError(error);
                  reject(error);
                  uploadLiveLog({
                    message: mute ? "麦克风静音失败" : "麦克风开启失败",
                    tag: "api",
                    level: "error",
                    extra: {
                      component: "WebTRTCService",
                      error: error,
                    },
                  });
                });
            } else {
              this.client
                .startLocalAudio({ mute: mute, publish: true })
                .then(() => {
                  this.audioStateSuccess = true;
                  resolve();
                  uploadLiveLog({
                    message: mute ? "麦克风静音成功" : "麦克风开启成功",
                    tag: "api",
                    extra: {
                      component: "WebTRTCService",
                      mute,
                    },
                  });
                })
                .catch((error) => {
                  this.handleMicrophoneError(error);
                  reject(error);
                  uploadLiveLog({
                    message: mute ? "麦克风静音失败" : "麦克风开启失败",
                    tag: "api",
                    level: "error",
                    extra: {
                      component: "WebTRTCService",
                      error: error,
                    },
                  });
                });
            }
          } else {
            reject();
            uploadLiveLog({
              message: "麦克风静音/开启",
              tag: "api",
              level: "error",
              extra: {
                component: "WebTRTCService",
                error: "没有实例对象",
              },
            });
          }
        } catch (error) {
          this.handleMicrophoneError(error);
          reject(error);
          uploadLiveLog({
            message: "麦克风静音/开启",
            tag: "api",
            level: "error",
          });
        }
      });
    };
    return this.queueAsyncAudio(asyncFn);
  }
  /**
   * 静音某个远端用户的音频，只对当前用户有效
   * @param {Object} params
   * @param {string} params.userId
   * @param {boolean} params.mute
   */
  muteRemoteAudio(params = {}) {
    return new Promise((resolve, reject) => {
      const { userId, mute } = params;
      try {
        if (this.client) {
          this.client
            .muteRemoteAudio(userId, mute)
            .then((res) => {
              resolve();
              uploadLiveLog({
                message: mute ? "静音远端用户音频成功" : "开启远端用户音频成功",
                tag: "api",
                extra: {
                  component: "WebTRTCService",
                  userId,
                  mute,
                },
              });
            })
            .catch((err) => {
              reject(err);
              uploadLiveLog({
                message: mute ? "静音远端用户音频失败" : "开启远端用户音频失败",
                tag: "api",
                level: "error",
                extra: {
                  component: "WebTRTCService",
                  error: err,
                  userId,
                  mute,
                },
              });
            });
        } else {
          reject("muteRemoteAudio——没有实例对象");
          uploadLiveLog({
            message: mute ? "静音远端用户音频失败" : "开启远端用户音频失败",
            tag: "api",
            level: "error",
            extra: {
              component: "WebTRTCService",
              error: "没有实例对象",
              userId,
              mute,
            },
          });
        }
      } catch (error) {
        reject(error);
        uploadLiveLog({
          message: mute ? "静音远端用户音频失败" : "开启远端用户音频失败",
          tag: "api",
          level: "error",
          extra: {
            component: "WebTRTCService",
            error: error,
            userId,
            mute,
          },
        });
      }
    });
  }
  /**
   * 开启麦克风测试
   *@returns void
   */
  startMicDeviceTest(params = {}) {
    const { interval = 500, playback } = params;
    // 开启音量回调，并设置每 500ms 触发一次事件
    this.client.enableAudioVolumeEvaluation(interval);
  }
  /**
   * 停止麦克风测试
   *@returns void
   */
  stopMicDeviceTest() {
    console.log("stopMicDeviceTest");
  }
  /**
   * 开启音量检测
   * @param {Object} params
   * @param {number} params.interval
   */
  enableAudioVolumeEvaluation(params = {}) {
    const { interval = 300, playback } = params;
    // 开启音量回调，并设置每 500ms 触发一次事件
    this.client.enableAudioVolumeEvaluation(interval);
  }
  getCurrentMicDevice() {
    const track = this.client.getAudioTrack();
    console.log("mic_track___", track);
    if (track) {
      const settings = track.getSettings();
      return {
        deviceId: settings.deviceId,
        deviceName: track.label,
      };
    } else {
      return null;
    }
  }
  handleMicrophoneError(error) {
    // 麦克风错误
    this._emit(EMIT_MAP.onMicrophoneError, {
      errCode: error.code,
      errMsg: "“麦克风”异常",
      errType: "microphone",
    });
  }
  // ----------------------------------------------------扬声器相关--------------------------------------
  /**
   * 获取扬声器设备列表;
   * @returns {Promise<Array>}
   * @property {Array} speaker - 麦克风列表
   * @property {string} speaker[].deviceId - 麦克风的ID
   * @property {string} speaker[].deviceName - 麦克风的名称
   * @property {string} speaker[].deviceProperties - 设备属性
   *
   */
  getSpeakerDevicesList() {
    return new Promise((resolve, reject) => {
      if (this.client) {
        TRTC.getSpeakerList()
          .then((res) => {
            console.log("new_live_web_getSpeakerDevicesList", res);
            const list = res.map((item) => {
              return {
                deviceId: item.deviceId,
                deviceName: item.label,
                isDefault: item.deviceId === "default",
                ...item,
              };
            });
            resolve(list);
          })
          .catch((err) => {
            console.error("new_live_web_getSpeakerDevicesList", err);

            reject(err);
          });
      } else {
        reject();
      }
    });
  }
  /**
   * 切换扬声器
   * @param {Object} params
   * @param {string} params.deviceId
   * @returns {Promise<void>}
   */
  setCurrentSpeakerDevice(params = {}) {
    return new Promise((resolve, reject) => {
      const { deviceId } = params;
      try {
        if (this.client) {
          TRTC.setCurrentSpeaker(deviceId)
            .then((res) => {
              resolve();
              uploadLiveLog({
                message: "设置扬声器成功",
                tag: "api",
                extra: {
                  component: "WebTRTCService",
                  deviceId,
                },
              });
            })
            .catch((err) => {
              console.log("设置扬声器失败", err);
              this.handleSpeakerError(err);
              reject(err);
              uploadLiveLog({
                message: "设置扬声器失败",
                tag: "api",
                level: "error",
                extra: {
                  component: "WebTRTCService",
                  error: err,
                  deviceId,
                },
              });
            });
          // resolve(TRTC.setCurrentSpeaker(deviceId));
        } else {
          reject();
          uploadLiveLog({
            message: "设置扬声器失败",
            tag: "api",
            level: "error",
            extra: {
              component: "WebTRTCService",
              error: "没有实例对象",
              deviceId,
            },
          });
        }
      } catch (error) {
        this.handleSpeakerError(error);
        reject(error);
        uploadLiveLog({
          message: "设置扬声器失败",
          tag: "api",
          level: "error",
          extra: {
            component: "WebTRTCService",
            error: error,
            deviceId,
          },
        });
      }
    });
  }
  /**
   * 设置系统当前扬声器设备音量 设置的扬声器音量，范围0 - 100
   * @param {Object} params
   * @param {number} params.volume
   */
  setCurrentSpeakerVolume(params) {
    const { volume } = params;
    this.client.setCurrentSpeakerVolume(volume);
  }
  //获取当前的扬声器设备
  getCurrentSpeakerDevice() {
    if (this.currentSpeaker) {
      return {
        deviceId: this.currentSpeaker.deviceId,
        deviceName: this.currentSpeaker.label,
      };
    } else {
      return null;
    }
  }
  handleSpeakerError(error) {
    // 扬声器错误
    this._emit(EMIT_MAP.onSpeakerError, {
      errCode: error.code,
      errMsg: "“扬声器”异常",
      errType: "speaker",
    });
  }
  // ----------------------------------------------------屏幕共享相关--------------------------------------
  /**
   * 启动屏幕共享
   * @returns {Promise<void>}
   */
  startScreenCapture() {
    return new Promise((resolve, reject) => {
      if (this.client) {
        this.client
          .startScreenShare({
            view: null,
            publish: false,
            option: {
              systemAudio: true,
              profile: this.screenShareProfile,
            },
          })
          .then((res) => {
            console.log("共享res", res);
            resolve(res);
          })
          .catch((error) => {
            console.log("共享error", error);
            this.handleScreenShareError(error);
            reject(error);
          });
      } else {
        reject();
      }
    });
  }
  /**
   * 停止屏幕共享
   * @returns {Promise<void>}
   */
  stopScreenCapture() {
    return new Promise((resolve, reject) => {
      if (this.client) {
        this.client
          .stopScreenShare()
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            this.handleScreenShareError(error);
            reject(error);
          });
      } else {
        reject();
      }
    });
  }
  updateScreenShare(config) {
    return new Promise((resolve, reject) => {
      if (this.client) {
        const { publish } = config;
        this.client
          .updateScreenShare({ publish })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            this.handleScreenShareError(error);
            reject(error);
          });
      } else {
        reject();
      }
    });
  }
  handleScreenShareError(error) {
    // 录屏错误
    this._emit(EMIT_MAP.onScreenShareError, {
      errCode: error.code,
      errMsg: "屏幕分享失败",
      errType: "screenShare",
    });
  }
  // ----------------------------------------------------消息相关--------------------------------------
  /**
   * 发送自定义消息
   * @param  {Object} params
   * @param  {Number} params.cmdId 消息 Id
   * @param  {String} params.data 消息内容
   */
  sendCustomMessage(params) {
    const { data, cmdId } = params;
    const encoder = new TextEncoder();
    this.client.sendCustomMessage({
      cmdId: cmdId,
      data: encoder.encode(data).buffer,
    });
  }
  setVideoMuteImage() {
    // todo
    console.warn("setVideoMuteImage is not supported in web environment");
  }

  //镜像
  setMirror(tag) {
    try {
      if (this.videoState) {
        this.client.updateLocalVideo({
          option: {
            mirror: tag ? "both" : false,
          },
        });
        store.commit("live/setIsMirror", tag);
      }
      if (this.testClient) {
        if (this.testVideoState) {
          this.testClient.updateLocalVideo({
            option: {
              mirror: tag ? "both" : false,
            },
          });
        }
      }
    } catch (error) {
      console.error("setMirror___", error);
    }
  }

  // 开启美颜
  startBasicBeauty({ beauty, brightness, ruddy }) {
    try {
      let params = {
        beauty: beauty / 100,
        brightness: brightness / 100,
        ruddy: ruddy / 100,
      };
      if (!store?.state?.live?.openBeauty) {
        this.client.startPlugin("BasicBeauty", params);
      }
      if (this.testClient) {
        this.testClient.startPlugin("BasicBeauty", params);
      }
      store.commit("live/setOpenBeauty", true);
    } catch (error) {
      console.error("startBasicBeauty___", error);
    }
  }
  //关闭美颜
  stopBasicBeauty() {
    try {
      this.client.stopPlugin("BasicBeauty");
      if (this.testClient) {
        this.testClient.stopPlugin("BasicBeauty");
      }
      store.commit("live/setOpenBeauty", false);
    } catch (error) {
      console.error("stopBasicBeauty___", error);
    }
  }
  //更新美颜
  updateBasicBeauty({ beauty, brightness, ruddy }) {
    try {
      let params = {
        beauty: beauty / 100,
        brightness: brightness / 100,
        ruddy: ruddy / 100,
      };
      this.client.updatePlugin("BasicBeauty", params);
      if (this.testClient) {
        this.testClient.updatePlugin("BasicBeauty", params);
      }
      store.commit("live/setOpenBeauty", true);
      store.commit("live/setBeautyOptions", { beauty, brightness, ruddy });
    } catch (error) {
      console.error("updateBasicBeauty___", error);
    }
  }
  //初始化美颜
  initBasicBeauty(client) {
    try {
      if (store?.state?.live?.openBeauty) {
        const { beauty, brightness, ruddy } = store?.state?.live?.beautyOptions;
        let params = {
          beauty: beauty / 100,
          brightness: brightness / 100,
          ruddy: ruddy / 100,
        };
        this[client].startPlugin("BasicBeauty", params);
      }
    } catch (error) {
      console.error("initBasicBeauty___", error);
    }
  }
  // 控制远端音频的播放音量
  setRemoteAudioVolume({ userId = "*", volume = 100 }) {
    this.client.setRemoteAudioVolume(userId, volume);
    uploadLiveLog({
      message: "Web-TRTC设置远端音频音量",
      level: "info",
      tag: "api",
      extra: {
        component: "WebTRTCService",
        userId,
        volume,
      },
    });
  }
  // 检测
  checkSystemRequirements() {
    return TRTC.isSupported();
  }

  // 切换用户角色，仅在 TRTC.TYPE.SCENE_LIVE 互动直播模式下生效。
  switchRole(role, option = {}) {
    TRTC.switchRole(role, option);
  }

  localVideoSwitch(type) {
    if (type === "start") {
      this.startLocalPreview();
    } else if (type === "stop") {
      this.stopLocalPreview();
    }
  }
}

export default WebTRTCService;
